<template>
  <div class="relative">
    <div>
      <div
        class="
          border-b
          bg-picker
          md:pt-56
          pt-48
          md:pb-48
          pb-36
          flex flex-col
          items-center
        "
      >
        <div class="container xxl:px-24">
          <h1 class="md:text-heading-xl text-heading mb-24 text-center">
            {{ $lang('support_page', 'heading') }}
          </h1>
          <div class="flex flex-wrap justify-center">
            <div
              v-for="link in supportLinks"
              :key="'support-link-' + link.id"
              class="flex relative mr-12 last:mr-0 mb-12"
            >
              <nuxt-link class="flex relative" :to="getRoute(link.id)">
                <div
                  class="
                    py-8
                    rounded-regular
                    text-small
                    border
                    flex
                    items-center
                    justify-center
                    transition-all
                    duration-200
                    relative
                    z-10
                    px-24
                    cursor-pointer
                    select-none
                  "
                  :class="{
                    'bg-white border-blue-50 text-standard':
                      pageDocument.id.toString() === link.id.toString(),
                    'border-secondary hover:bg-white hover:border-blue-50 bg-picker text-black-75':
                      pageDocument.id.toString() !== link.id.toString(),
                  }"
                >
                  {{ link.title }}
                </div>
                <div
                  v-if="pageDocument.id.toString() === link.id.toString()"
                  class="
                    absolute
                    inset-selected-border
                    rounded-regular
                    bg-secondary
                  "
                />
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full overflow-hidden support-blocks">
        <component
          :is="BlockComponents[component.layout]"
          v-for="(component, idx) in pageDocument.components"
          :key="component.layout + idx"
          v-bind="{ component }"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Page from '~/models/page';
import type { ContentData } from '~/constants/types/page';
import BlockComponents from '~/constants/block-components';
import { type Route } from '~/constants/types/route';
import { useConfigStore } from '~/store/config';

const config = useConfigStore();

const props = defineProps<{
  page: ContentData,
}>();

const pageDocument = computed(()=>{
  return new Page({ contentData: props.page });
});

const supportLinks = computed<Route[]>(()=>{
  const supportLinks = config.getSupportLinks();
  return (
    (supportLinks &&
      supportLinks.sort((a, b) => {
        const aOrder = a.order;
        const bOrder = b.order;
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      })) ||
    []
  );
});

const getRoute = (id: number) => {
  const route = config.pageById(id);
  return route?.route || '/';
};

</script>

<style scoped lang="postcss">
</style>
